/*
 * @Description:
 * @Author: Jack Deng
 * @Date: 2021-03-02 16:31:52
 * @LastEditors: Jack Deng
 * @LastEditTime: 2021-11-24 15:08:33
 * @FilePath: /unifyxp-v2-store-portal/src/tools/constant.ts
 */
import { randomNumber, reduxDefaultStatusControl } from 'src/tools/helper';
import { ChannelType } from 'src/types/common/SalesChannel';
import { EnumStatus } from '../types/common/common';

export const defaultStatus = reduxDefaultStatusControl;
export const changedStatus = {
  lastSubmitStamp: randomNumber(),
  loaded: true,
};

export const INDEX_DB = 'Homepage';
export const INDEX_DB1 = 'ContentConfigDraft';

export const CURRENT_SALES_CHANNEL_UUID = 'CURRENT_SALES_CHANNEL_UUID';
export const CURRENT_SALES_CHANNEL = 'CURRENT_SALES_CHANNEL';

export const salesChannelType = {
  [ChannelType.Website]: 'Website',
};
export const siderWidth = 240;
export const entireTimeFormat1 = 'DD MMM YYYY HH:mm';
export const entireTimeFormat2 = 'YYYY-MM-DD HH:mm';
export const timeOnlyFormat = 'HH:mm';
export const dateWithSeconds = 'MM-DD-YYYY hh:mm:ss a';

export const dateFormat = 'YYYY-MM-DD HH:mm';
export const dateOnlyFormat = 'YYYY-MM-DD';
export const hoursAndMinOnlyFormat = 'HH:mm';
export const hmsFormat = 'HH:mm:ss';

export const blackColor = '#000';
export const whiteColor = '#fff';
export const textColors = [whiteColor, blackColor];
export const defaultPageSize = 60;
export const maxMoney = 100000000;
export const maxTimes = 10000;
export const maxAmount = 100000000;

export const separateSymbol = '==-^-==';

export const ACCOUNT_INFO = 'ACCOUNT_INFO';
export const SEVER_URL = 'SEVER_URL';

export const PLAN_REMINDER = 'PLAN_REMINDER';

export const SYS_LANGUAGE = 'SYS_LANGUAGE';
export const GENERAL = 'General';

export const USER_INFO_IN_STORAGE = 'unifyPortalUserInfo';
export const USER_LANGUAGE = 'unifyPortalUserLanguage';
export const EXP = 'portal_EXP';
export const SIDER = 'portal_S';
export const ROUTER = 'portal_R';
export const NEW = 'new';
export const NULL = 'null';
export const IMAGE_URL = 'https://resource2.unifyxp.com/';
export const ICON_PREFIX = `${IMAGE_URL}shopper-v2/pc/`;
export const expandsWidth = 50;
export const rowSelectionWidth = 80;
export const yScrollWidth = 24;
export const queryMenuId = 'QuerySearchContainer';
export const SALES_CHANNELS_MULTI_LANG_PROPS = '__salesChannelMultiLanguage';
export const UPLOAD_FILE_EXT_RESTRICTIONS = [
  'apng',
  'jpg',
  'jpeg',
  'gif',
  'png',
  'svg',
  'pdf',
  'mov',
  'mp4',
  'webp',
];
export const UPLOAD_IMAGE = [
  'apng',
  'jpg',
  'jpeg',
  'gif',
  'png',
  'svg',
  'pdf',
  'webp',
];
export const UPLOAD_VIDEO = ['mov', 'mp4'];
export const POPUP_PLACEHOLDER =
  'https://resource2.unifyxp.com/shopper-v2/h5/popup_placeholder.svg';

export const ANIMATION_PREFIX =
  'https://resource2.unifyxp.com/unifyxp2/default/responsive/animation/';

export const UNIFY_OFFICIAL_LINK = 'https://unifyxp.com/ ';

export const sectionProps = {
  size: 'small',
  bottomBorder: false,
  style: { paddingTop: 0 },
};

export const FONT_LIST = [
  { value: 'Open Sans', label: 'Open Sans' },
  { value: 'Garamond', label: 'Garamond' },
  {
    value: 'Merriweather',
    label: 'Merriweather',
  },
  {
    value: 'Roboto Slab',
    label: 'Roboto Slab',
  },
  {
    value: 'Playfair Display',
    label: 'Playfair Display',
  },
  {
    value: 'Lora',
    label: 'Lora',
  },
  {
    value: 'PT Serif',
    label: 'PT Serif',
  },
  {
    value: 'Roboto',
    label: 'Roboto',
  },
  {
    value: 'Noto Sans JP',
    label: 'Noto Sans JP',
  },
  {
    value: 'Lato',
    label: 'Lato',
  },
  {
    value: 'Montserrat',
    label: 'Montserrat',
  },
  {
    value: 'Roboto Mono',
    label: 'Roboto Mono',
  },
  {
    value: 'Inconsolata',
    label: 'Inconsolata',
  },
  {
    value: 'Source Code Pro',
    label: 'Source Code Pro',
  },
  {
    value: 'PT Mono',
    label: 'PT Mono',
  },
  {
    value: 'IBM Plex Mono',
    label: 'IBM Plex Mono',
  },
  {
    value: 'zt_neue_ralewe',
    label: 'zt_neue_ralewe',
  },
];

export const GENERIC_FONT = [
  {
    value: 'Serif',
    label: 'Serif',
  },
  {
    value: 'Sans serif',
    label: 'Sans-serif',
  },
  {
    value: 'System ui',
    label: 'System-ui',
  },
];
export const SENTRY_DSN =
  'https://fe9197ee716c45fe9af5363444815af1@o4504523570479104.ingest.sentry.io/4504534090776576';

export const I18N_KEY_MAPPING = {
  [EnumStatus.Active]: 'general.status.active',
  [EnumStatus.Draft]: 'general.status.draft',
  [EnumStatus.Scheduled]: 'general.status.scheduled',
  [EnumStatus.Issued]: 'general.status.issued',
  [EnumStatus.Expired]: 'general.status.expired',
  [EnumStatus.Archived]: 'general.status.archived',
  [EnumStatus.ZeroBalance]: 'general.statusTag.zero_balance',
  [EnumStatus.Used]: 'general.status.used',
  [EnumStatus.Locked]: 'general.status.locked',
};

export const moreThanOneExclusiveCodeErrorCodes = [
  205125, 205126, 205127, 205135, 205136, 205137, 205149,
];

export const UPDATE_GLOBAL_CONFIG_SCS = 'UPDATE_GLOBAL_CONFIG_SCS';
export const UPDATE_STORE_SETTING = 'UPDATE_STORE_SETTING';
export const UPDATE_SC_SETTING = 'UPDATE_SC_SETTING';

export const STORE_DATE_FORMAT = 'STORE_DATE_FORMAT';
export const STORE_TIME_FORMAT = 'STORE_TIME_FORMAT';
export const STORE_UTC = 'STORE_UTC';
export const STORE_TIMEZONE = 'STORE_TIMEZONE';

export const CURRENT_SC_DATE_FORMAT = 'CURRENT_SC_DATE_FORMAT';
export const CURRENT_SC_TIME_FORMAT = 'CURRENT_SC_TIME_FORMAT';
export const CURRENT_SC_UTC = 'CURRENT_SC_UTC';
export const CURRENT_SC_TIMEZONE = 'CURRENT_SC_TIMEZONE';
